import {type StoppageCategoryCounts} from '../types'

export const getStoppageCategoryCountPlaceHolders = (
  data: StoppageCategoryCounts[],
  currentYear: number
): StoppageCategoryCounts[] => {
  // if the data does not have months for the entire year, fill in the gaps with placeholders
  const monthsInYear = Array.from({length: 12}, (_, i) => i + 1)
  const dataMonths = data.map((item) => item.month)
  const missingMonths = monthsInYear.filter((month) => !dataMonths.includes(month))
  const placeholders: StoppageCategoryCounts[] = missingMonths.map((month) => ({
    month,
    year: currentYear,
    electricalCount: 0,
    mechanicalCount: 0,
    processCount: 0,
    otherCount: 0
  }))
  return placeholders
}
